<template>
  <div class="big">
    <DocMsg
      :isFlag="doc_msg"
      :doctorId="doctorId"
    ></DocMsg>
    <div class="page_title flex_between">
      <span>
        <span>项目推荐奖励详情</span>
      </span>
      <el-button
        type="primary"
        style="width:92px;"
        size="medium"
        @click="back"
      >返回</el-button>
    </div>
    <div class="box">
      <div class="container">
        <div class="infobox">
          <div class="info">
            <div>
              <span class="infotitle">用户昵称：</span>
              <span>{{detail.nick_name}}</span>
            </div>
            <div style="margin:14px 0">
              <span class="infotitle">性别：</span>
              <span v-if="detail.user_sex==1">男</span>
              <span v-if="detail.user_sex==2">女</span>
              <span v-if="detail.user_sex==0">未知</span>
            </div>
            <div>
              <span class="infotitle">手机号：</span>
              <span>{{detail.user_phone}}</span>
            </div>
          </div>
          <div
            class="info"
            style="margin:0 20px"
          >
            <div>
              <span class="infotitle">患者姓名：</span>
              <span>{{detail.user_name}}</span>
            </div>
            <div style="margin:14px 0">
              <span class="infotitle">性别：</span>
              <span v-if="detail.sex==1">男</span>
              <span v-if="detail.sex==2">女</span>
              <span v-if="detail.sex==0">未知</span>
            </div>
            <div>
              <span class="infotitle">年龄：</span>
              <span>{{detail.age}}</span>
            </div>
          </div>
          <div class="info">
            <div>
              <span class="infotitle">医生姓名：</span>
              <span
                @click="showDocMsg(detail.doctor_id)"
                style="cursor:pointer"
              >{{detail.doctor_name}}</span>
            </div>
            <div style="margin:14px 0">
              <span class="infotitle">性别：</span>
              <span>{{detail.doctor_sex==1?"男":"女"}}</span>
            </div>
            <div>
              <span class="infotitle">手机号：</span>
              <span>{{detail.doctor_phone}}</span>
            </div>
          </div>
        </div>
        <div class="item">
          <div style="margin-bottom:10px">
            <span class="gray">交易单号：</span>
            <span>{{detail.order_sn}}</span>
          </div>
          <div>
            <span class="gray">支付时间：</span>
            <span>{{detail.pay_time}}</span>
            <span
              class="gray"
              style="margin-left:100px"
            >支付金额：</span>
            <span>{{detail.pay_money}}</span>
          </div>
          <div
            style="margin-top:10px"
            v-if="detail.status==5"
          >
            <span class="gray">退款时间：</span>
            <span>{{detail.refund_time}}</span>
            <span
              class="gray"
              style="margin-left:100px"
            >退款金额：</span>
            <span>-{{detail.refund_money}}</span>
          </div>
        </div>
        <div class="item">
          <div class="flex align-center">
            <div>
              <span class="gray">项目类型：</span>
              <span v-if="detail.pro_type==1">体检项目</span>
              <span v-if="detail.pro_type==2">商品</span>
            </div>
            <div style="margin:0 60px">
              <span class="gray">项目名称：</span>
              <span>{{detail.pro_name}}</span>
            </div>
            <div>
              <span class="gray">销售价格：</span>
              <span>{{detail.price}}</span>
            </div>
          </div>
          <div style="margin-top:14px">
            <span style="color:#f24e33;font-weight:600">推荐奖励：</span>
            <span style="color:#f24e33;font-weight:600">{{detail.reward_price}}</span>
          </div>
        </div>

        <div class="item">
          <div>
            <span class="gray">订单状态：</span>
            <span v-if="detail.status==2">已支付</span>
            <span v-if="detail.status==3">已支付</span>
            <span v-if="detail.status==4">已完成</span>
            <span v-if="detail.status==5">已作废</span>
            <span v-if="detail.status==6">已作废</span>
            <span
              v-if="detail.status==5"
              style="margin-left:100px"
            >
              <span class="gray">作废类型：</span>
              <span>平台退款</span>
            </span>
          </div>
          <div>
            <div style="margin-top:10px">
              <span class="gray">结算状态：</span>
              <span v-if="detail.doc_settlement==1">待系统核算</span>
              <span v-if="detail.doc_settlement==2">待结算</span>
              <span v-if="detail.doc_settlement==3">已结算</span>
              <span v-if="detail.doc_settlement==4">已退款</span>
            </div>
            <div
              v-if="detail.doc_settlement==3||detail.doc_settlement==2"
              style="margin-top:10px"
            >
              <div>
                <span class="gray">预结算时间：</span>
                <span>{{detail.over_time}}</span>
              </div>
              <div style="margin-top:10px">
                <span class="gray">结算帐期：</span>
                <span>{{detail.period}}</span>
              </div>
              <div
                style="margin-top:10px"
                v-if="detail.doc_settlement==3"
              >
                <span class="gray">结算入账时间：</span>
                <span>{{detail.sa_time}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import doctor_fee from '../../../api/doctor_fee';
import DocMsg from '../../../components/common/DocMsg.vue';
import moment from 'moment';

export default {
  data() {
    return {
      detail: {},
      doc_msg: false,
      doctorId: ''
    };
  },
  components: {
    DocMsg
  },
  methods: {
    back() {
      history.back();
    },
    //医生信息概要
    showDocMsg(doctor_id) {
      this.doctorId = doctor_id;
      this.doc_msg = !this.doc_msg;
    },
    getDetail() {
      let order_id = this.$route.query.order_id;
      doctor_fee.getDoctorRewardDetail({ order_id }).then((res) => {
        if (res.code == 0) {
          this.detail = res.data.info;
          this.detail.pay_time = moment
            .unix(this.detail.pay_time)
            .format('YYYY-MM-DD HH:mm');
          this.detail.refund_time = this.detail.refund_time
            ? moment.unix(this.detail.refund_time).format('YYYY-MM-DD HH:mm')
            : '';
          this.detail.over_time = this.detail.over_time
            ? moment.unix(this.detail.over_time).format('YYYY-MM-DD HH:mm')
            : '';
          this.detail.sa_time = this.detail.sa_time
            ? moment.unix(this.detail.sa_time).format('YYYY-MM-DD HH:mm')
            : '';
          this.detail.period = this.detail.period
            ? moment.unix(this.detail.period).format('YYYY-MM')
            : '';
        }
      });
    }
  },
  created() {
    this.getDetail();
  }
};
</script>
<style lang="scss" scoped>
.box {
  padding: 20px;
}
.container {
  padding: 20px;
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
  text-align: left;
}
.infobox {
  display: flex;
  .info {
    background-color: #f9f8ee;
    border: solid 1px #dad8ca;
    padding: 14px 60px 14px 20px;
  }
}
.item {
  border: solid 1px #cfcece;
  padding: 20px;
  margin-top: 20px;
}
.gray {
  color: #747981;
  font-weight: 600;
}
.infotitle {
  display: inline-block;
  width: 75px;
}
</style>